import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import Select from 'react-select';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class CityFilter extends Component {
    state = {
        cityLists:[],
        cityValue:null,
        isCityLoading: true
    };
    componentDidMount(){
        this._get_city();
    }

    resetCityFilter(){
        this.setState({
        cityValue: [],
        })
    }
     _get_city(){
        axios.get(config.get('API_URL')+'/reports/get-city/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((city, index) => {
                    this.state.cityLists.push({value: city.city_name, label: city.city_name})
                });
            }
        });
        this.setState({
            loading:false
        })
    }
    changeCity(optionSelected){
        let value='';
        let cityArray = [];
        if(optionSelected.length < 1){
            value = null;
            cityArray='';
        }
        else{
            optionSelected.map((mids, i) => {
                cityArray.push(mids.value)
                var index = this.state.cityLists.findIndex(obj => obj.value==mids.value);
                this.state.cityLists.move(index,0).join(',');

            });
        }
        this.props.onSelectCity(optionSelected,cityArray);
        this.setState({
            cityValue:optionSelected,
        });
    }
    render() {

        return (
            <ReactMultiSelectCheckboxes name="city"
            isMulti
            value={this.state.cityValue}
            styles={reactSelectStyles} className="report-listbox"
            isClearable={false}
            onChange={this.changeCity.bind(this)}
            options={this.state.cityLists}
            placeholderButtonLabel="Select [City]"
        />
        );

    }
}
export default CityFilter;